import login from './login'
import nav from './_nav.json'
import activity from './activity'
import dict from './dict.json'
import demo from './demo.json'

export default {
  site_title: 'JDYun.com',
  title: 'ระบบกิจกรรม JDYun',
  system_demo: 'สาธิตระบบ',
  confirm: 'ยืนยัน',
  cancel: 'ยกเลิก',
  show: 'แสดง',
  hide: 'ซ่อน',
  open: 'เปิด',
  close: 'ปิด',
  save: 'บันทึก',
  edit: 'แก้ไข',
  delete: 'ลบ',
  add: 'เพิ่ม',
  search: 'ค้นหา',
  query: 'สอบถาม',
  reset: 'รีเซ็ต',
  submit: 'ส่ง',
  upload: 'อัปโหลด',
  download: 'ดาวน์โหลด',
  export: 'ส่งออก',
  import: 'นำเข้า',

  started: 'เริ่มต้น',
  ended: 'สิ้นสุด',
  next: 'ถัดไป',
  prev: 'ก่อนหน้า',
  publish: 'เผยแพร่',
  input: 'กรุณาป้อน {text}',
  select: 'กรุณาเลือก {text}',
  total: 'ทั้งหมด {total}',
  price: '{price} หยวน',
  required: 'จำเป็นต้องกรอก {text}',
  selected: 'เลือก {total} {text}',
  create: 'สร้าง',
  free: 'ฟรี',
  charge: 'มีค่าใช้จ่าย',
  default: 'ค่าเริ่มต้น',
  custom: 'กำหนดเอง',
  max: 'สูงสุด',
  min: 'ต่ำสุด',
  percent: 'เปอร์เซ็นต์',
  online: 'ออนไลน์',
  offline: 'ออฟไลน์',
  name: 'ชื่อ',
  remark: 'หมายเหตุ',
  tips: 'เคล็ดลับ',
  header: {
    logout: 'ออกจากระบบ',
    binding: 'เชื่อมโยงบัญชี',
    mobile: 'แอปมือถือสำหรับร้านค้า',
    register: 'แอปมือถือ',
    tips: 'กิจกรรม {name}',
    qrcodeText: 'รหัส QR H5 {name}',
    qrcodeMiniText: 'รหัสมินิโปรแกรม {name}',
    qrcode: 'คลิกเพื่อดาวน์โหลดรหัส QR',
    qrcodeMini: 'คลิกเพื่อดาวน์โหลดรหัสมินิโปรแกรม'
  },
  home: {
    title: 'ยินดีต้อนรับสู่แพลตฟอร์มการจัดการกิจกรรม Jindouyun',
    sub_title: 'เผยแพร่กิจกรรมและงานประชุมที่ครบถ้วนและละเอียดที่สุดที่นี่',
    desc: 'เริ่มการเดินทางจัดกิจกรรมของคุณจากการจัดการกิจกรรม',
    create: 'สร้างกิจกรรมอย่างรวดเร็ว'
  },
  user: {
    title: 'ข้อมูลพื้นฐานของบัญชี',
    logo: 'โลโก้แบรนด์',
    update: 'อัปเดต',
    name: 'ชื่อบริษัทหรือองค์กร',
    short_name: 'แบรนด์ในแถบเมนูด้านบนซ้าย',
    enable: 'เปิดการเข้าสู่ระบบแบบกำหนดเอง',
    web_tips: 'URL เข้าสู่ระบบแบบกำหนดเอง',
    copy: 'คัดลอก URL',
    login: 'ชื่อแบรนด์ในหน้าเข้าสู่ระบบ',
    login_title: 'ชื่อระบบในหน้าเข้าสู่ระบบ'
  },
  login,
  activity,
  demo,
  ...nav,
  ...dict,
  // CODE_SUCCESS: 2000,
  2000: 'การดำเนินการสำเร็จ',
  // CODE_ERROR: 5000,
  5000: 'ข้อผิดพลาดในการร้องขอเครือข่าย โปรดตรวจสอบเครือข่ายของคุณ',
  // CODE_ERROR_PARAMS: 5001,
  5001: 'พารามิเตอร์การร้องขอไม่ถูกต้อง',
  // URL注册失败
  // CODE_ERROR_URL_REG_FAILURE: 5002,
  5002: 'การลงทะเบียน URL ล้มเหลว',
  // CODE_ERROR_NO_PARAM: 5003,
  5003: 'ข้อผิดพลาดของพารามิเตอร์',
  // CODE_ERROR_PERSSION_ERROR: 5004,
  5004: 'ข้อผิดพลาดของสิทธิ์',
  // JWT 验证错误
  // CODE_JWT_ERROR: 5100,
  5100: 'การตรวจสอบ JWT ล้มเหลว',
  // CODE_JWT_LOGIN_FAILURE: 5101,
  5101: 'การเข้าสู่ระบบล้มเหลว',
  // JWT Token 无效
  // CODE_JWT_TOKEN_INVALID: 5102,
  5102: 'JWT ไม่ถูกต้อง',
  // CODE_JWT_NO_USER: 5103,
  5103: 'ไม่มีผู้ใช้',
  //
  // CODE_PARAMS_TYPE_ERROR_SIZE = 5401
  5401: 'พารามิเตอร์ size มีข้อผิดพลาด',
  //
  // CODE_PARAMS_TYPE_ERROR_PAGE = 5402
  5402: 'พารามิเตอร์ page มีข้อผิดพลาด',
  //
  // CODE_PARAMS_TYPE_ERROR_QUERY = 5403
  5403: 'คำสำคัญในการสอบถามมีข้อผิดพลาด'
}



// WEBPACK FOOTER //
// ./src/langs/th/index.js